/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendEmailAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SendEmailAction({
  children,
  viewPath = "/DesignSystem/SendPatientMessage/SendEmailAction"
  
}) {
let selectedSendToPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'send_to_person_id',
})
let onClick = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="normal"
 onClick={onClick}
 data="selected.send_to_person_id"
 disabled={!selectedSendToPersonIdValueData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send email"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}